import * as ngCore from '@angular/core'
import * as ds from '@attain-apps/fe/web/main/lib/design'

import * as state from '../../../../../../state'

import * as connectorModal from './connector-modal'
import * as definitionModal from './definition-modal'

/** Manages integration connector definitions and zone connector instances. */
@ngCore.Component({
  imports: [
    ds.overlay.confirmation.Component,
    ds.table.Component,
    ds.tabs.integratedHorizontal.Component,
    ds.tabs.tab.Directive,
    connectorModal.Component,
    definitionModal.Component,
  ],
  selector: 'atn-admin-zone-page-integrations-tab',
  styleUrls: ['./component.scss'],
  templateUrl: './component.html',
})
export class Component {
  /** Connector definitions for the active Admin zone. */
  public readonly definitionsEc = ngCore.inject(
    state.integrations.connectorDefinitions.Collection,
  )

  /** Connector instances for the active Admin zone. */
  public readonly connectorsEc = ngCore.inject(
    state.integrations.connectors.Collection,
  )

  /** Canonical table view for connector definitions. */
  public readonly definitionsTableConfig = {
    collection: this.definitionsEc,
    view: {
      creation: true,
      search: true,
      showColumnSettings: false,
      title: 'Connector definitions',
    },
  } satisfies ds.table.ec.Config.Input<state.integrations.connectorDefinitions.TypeParams>

  /** Canonical table view for connectors. */
  public readonly connectorsTableConfig = {
    collection: this.connectorsEc,
    view: {
      creation: true,
      search: true,
      showColumnSettings: false,
      title: 'Connectors',
    },
  } satisfies ds.table.ec.Config.Input<state.integrations.connectors.TypeParams>

  /** Confirms deletion of the connector definition marked by the table. */
  public confirmDefinitionDeletion(): void {
    this.definitionsEc.plugins.editingPlugin.feature.actions.submit
      .from('Integrations.Definitions.Delete.Confirmed')
      .dispatch({ delete: true })
  }

  /** Cancels deletion of the connector definition marked by the table. */
  public cancelDefinitionDeletion(): void {
    this.definitionsEc.plugins.editingPlugin.feature.actions.discard
      .from('Integrations.Definitions.Delete.Cancelled')
      .dispatch({ delete: true })
  }

  /** Confirms deletion of the connector marked by the table. */
  public confirmConnectorDeletion(): void {
    this.connectorsEc.plugins.editingPlugin.feature.actions.submit
      .from('Integrations.Connectors.Delete.Confirmed')
      .dispatch({ delete: true })
  }

  /** Cancels deletion of the connector marked by the table. */
  public cancelConnectorDeletion(): void {
    this.connectorsEc.plugins.editingPlugin.feature.actions.discard
      .from('Integrations.Connectors.Delete.Cancelled')
      .dispatch({ delete: true })
  }
}
